import React, { CSSProperties } from 'react';
import { Features } from '../../../assets/features/Features';
import { useLanguage } from '../../../context/LanguageContext';
import { useTheme } from '../../../context/ThemeContext';

const FirstSession: React.FC = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  const cardStyle: CSSProperties = {
    backgroundColor: isDarkMode ? '#2a2c2e' : '#ffffff',
    border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease',
  };

  const steps = [
    {
      icon: 'bi-clipboard2-pulse',
      data: Features.firstSession.steps.evaluation,
      number: '01',
    },
    {
      icon: 'bi-hand-index-thumb',
      data: Features.firstSession.steps.treatment,
      number: '02',
    },
    {
      icon: 'bi-graph-up-arrow',
      data: Features.firstSession.steps.followUp,
      number: '03',
    },
  ];

  return (
    <section id="first-session" className="first-session section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{Features.firstSession.title[language]}</h2>
      </div>

      <div className="container">
        <div className="row gy-4 justify-content-center">
          {steps.map((step, index) => (
            <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={`${(index + 1) * 100}`}>
              <div className="p-4 rounded-4 shadow-sm h-100 text-center" style={cardStyle}>
                <div className="mb-3">
                  <span
                    className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                    style={{ width: '60px', height: '60px', fontSize: '1.5rem' }}
                  >
                    <i className={`bi ${step.icon}`}></i>
                  </span>
                </div>
                <span className="badge bg-primary bg-opacity-10 text-primary mb-2" style={{ fontSize: '0.75rem' }}>
                  {step.number}
                </span>
                <h4 className="fw-bold mb-3" style={isDarkMode ? { color: '#ffffff' } : {}}>
                  {step.data.title[language]}
                </h4>
                <p style={isDarkMode ? { color: '#d1d5db' } : {}}>
                  {step.data.description[language]}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FirstSession;
